import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import FacebookLogin from 'react-facebook-login';

import Config from 'configuration';

import { facebookLogin } from 'actions/user';

import redirectAfterLogin from './redirectAfterLogin';

export class FacebookLoginContainer extends Component {
  handleCallback = async (res) => {
    const { dispatch, history } = this.props;
    const data = await dispatch(facebookLogin(res));
    // Move the user to where they need to be next
    redirectAfterLogin(history, data);
  }

  render = () => {
    const { label } = this.props;
    const { facebookAppId } = Config;
    return (
      <FacebookLogin
        appId={facebookAppId}
        autoLoad={false}
        cssClass="button button--menlo-park-panopticon"
        fields="name,email,picture"
        textButton={(
          <span>
            <i className="fa fa-facebook-official fa-2x" />
            {' '}
            {label}
          </span>
        )}
        callback={this.handleCallback}
        version="3.1"
      />
    );
  }
}

FacebookLoginContainer.propTypes = {
  label: PropTypes.string.isRequired,
};

export default withRouter(connect()(FacebookLoginContainer));